// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"1e2fde14","353":"66de2cd0","460":"9fac540c","566":"be61944b","663":"b54d0772"}[chunkId] + ".chunk.js";
};